<template>
	<div class="login">
		<div class="container">
			<div class="header clearfix">
				<div class="logo col-lg-9 col-md-9 col-xs-6">
					<img src="../../static/images/logo.png" />
				</div>
				<div class="goBack col-lg-3 col-md-3 col-xs-6">
					<router-link class="goBackBox" tag='div' to='/home'>
						<div class="goBackBox-center">
							<img src="../../static/images/icon/backIcon.png" />
							<span>返回首页</span>
						</div>
					</router-link>
				</div>
			</div>
			<div class="login-center clearfix">
				<div class="login-l">
					<img src="../../static/images/register-l.png" />
				</div>
				<div class="login-r">
					<div class="shadow register-shadow">
						<img src="../../static/images/shadow.png" />
					</div>
					<div class="login-box">
						<div class="title register-title">
							<span>注册后即可开始试用</span>
						</div>
						<div class="form-box register-form-box">
							<el-form :model="form" :rules="ruleForm" ref="form">
								<el-form-item prop="phone">
									<div class="form-item">
										<span>
											<img src="../../static/images/icon/icon-phone.png" />
										</span>
										<el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
									</div>
								</el-form-item>
								<el-form-item prop="yzmCode">
									<div class="form-item">
										<span>
											<img src="../../static/images/icon/icon-yzm.png" />
										</span>
										<div class="inputBox">
											<el-input v-model="form.yzmCode" placeholder="请输入验证码" class="getInputCode"></el-input>
											<span class="getCode">获取验证码</span>
										</div>
									</div>
								</el-form-item>
								<el-form-item prop="password">
									<div class="form-item">
										<span>
											<img src="../../static/images/icon/icon-code.png" />
										</span>
										<el-input v-model="form.password" placeholder="请输入密码" type="password"></el-input>
									</div>
								</el-form-item>
								<el-form-item prop="checkPass">
									<div class="form-item">
										<span>
											<img src="../../static/images/icon/icon-code.png" />
										</span>
										<el-input v-model="form.checkPass" placeholder="请再次输入密码" type="password"></el-input>
									</div>
								</el-form-item>
								<el-form-item>
									<el-button @click="submitForm('form')">注&nbsp;&nbsp;&nbsp;&nbsp;册</el-button>
								</el-form-item>
							</el-form>
						</div>
						<div class="footer-num">
							<span>服务电话:020-29815512</span>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'register',
		data() {
				var phonePass = (rule, value, callback) => {
				var myreg = /^[1][3-9][0-9]{9}$/;
				if (value === "") {
					callback(new Error('请输入手机号码'));
				} else if (!myreg.test(value)) {
					callback(new Error("请输入正确的手机号码"));
				} else {
					callback(); //重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
				}
			};
			var passwordPass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error('请输入密码'));
				}else if(this.form.checkPass !== ''){
					this.$refs.form.validateField('checkPass')
				} else {
					callback();
				}
			};
			var yzmCodePass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			};
			var checkPass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error('请再次输入密码'));
				}else if(value !== this.form.password){
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				form:{
					phone:'',
					yzmCode:'',
					password:'',
					checkPass:''
				},
				ruleForm: {
					phone: [{
						validator: phonePass,
						trigger: 'blur'
					}],
					password: [{
						validator: passwordPass,
						trigger: 'blur'
					}],
					yzmCode: [{
						validator: yzmCodePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: checkPass,
						trigger: 'blur'
					}],
				}
			}
		},
		methods:{
				submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}
	}
</script>

<style scoped>
.register-title{
	width: 100% !important;
	text-align: center;
	font-size: 16px;
	font-weight: bold;
}
.register-form-box{
	border-bottom: none !important;
}
.register-Btn{
	margin-top: 10px!important;
}
.register-shadow{
	position: absolute;
	bottom: 140px!important;
	left: 87px!important;
}
</style>




// WEBPACK FOOTER //
// src/components/register.vue